module.exports = __webpack_public_path__ + "img/bg.0e9f8c37.png";